import React, { useEffect } from 'react';
import { arrayOf, bool, func, number, shape } from 'prop-types';
import CustomFormItem from 'Src/common/components/customFormItem';
import { Col } from 'antd';
import { Form } from '@ant-design/compatible';
import { getFormEntryRecord } from 'Src/common/utilities/form_utils';
import FormWrapper from '../formWrapper';
import './style.scss';

function StepFive({ fields, form, totalSteps, lastStep, submitLastStep, registrationFormEntry }) {
  useEffect(() => {
    if (lastStep) {
      submitLastStep(form);
    }
  }, [lastStep]);

  return (
    <div className="mentorship-step-five">
      <FormWrapper
        totalSteps={totalSteps}
        step={totalSteps}
        header={<h3 className="arc-H300">Just a bit more info</h3>}>
        <Form layout="vertical">
          {fields.map((field) => (
            <Col lg={12} xl={12} xs={24} key={field.id}>
              <CustomFormItem
                key={field.id}
                form={form}
                formInput={field}
                formRecord={getFormEntryRecord(registrationFormEntry, field.id, field.type)}
                metadata={{
                  source_type: 'customform',
                  access_level: 'protected',
                  source_id: window.programDetails?.registration_form?.id,
                }}
              />
            </Col>
          ))}
        </Form>
      </FormWrapper>
    </div>
  );
}

StepFive.propTypes = {
  fields: arrayOf(shape()).isRequired,
  form: shape().isRequired,
  lastStep: bool.isRequired,
  registrationFormEntry: shape().isRequired,
  submitLastStep: func.isRequired,
  totalSteps: number.isRequired,
};

export default Form.create()(StepFive);
